// 세션 관리를 위한 유틸리티 함수들

/**
 * 세션 쿠키가 존재하는지 확인
 */
// export function hasSessionCookie(): boolean {
//   if (typeof document === 'undefined') return false;
  
//   return document.cookie
//     .split(';')
//     .some(cookie => cookie.trim().startsWith('nsm_session='));
// }

/**
 * 세션 쿠키 가져오기
 */
export function getSessionCookie(): string | null {
  if (typeof document === 'undefined') return null;
  
  const cookies = document.cookie.split(';');
  const sessionCookie = cookies.find(cookie => 
    cookie.trim().startsWith('nsm_session=')
  );
  
  return sessionCookie ? sessionCookie.split('=')[1] : null;
}

/**
 * 세션 쿠키 삭제
 */
export function clearSessionCookie(): void {
  if (typeof document === 'undefined') return;
  
  document.cookie = 'nsm_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

/**
 * 세션 상태 확인을 위한 헤더 생성
 */
export function getSessionHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };
  
  // const sessionId = getSessionCookie();
  // if (sessionId) {
  //   headers['X-Session-ID'] = sessionId;
  // }
  
  return headers;
} 